export const GET_PUBLICATIONS_BEGIN = "GET_PUBLICATIONS_BEGIN";
export const GET_PUBLICATIONS_SUCCESS = "GET_PUBLICATIONS_SUCCESS";
export const GET_PUBLICATIONS_ERROR = "GET_PUBLICATIONS_ERROR";

export const GET_PUBLICATIONS_SINGLE_BEGIN = "GET_PUBLICATIONS_SINGLE_BEGIN";
export const GET_PUBLICATIONS_SINGLE_SUCCESS = "GET_PUBLICATIONS_SINGLE_SUCCESS";
export const GET_PUBLICATIONS_SINGLE_ERROR = "GET_PUBLICATIONS_SINGLE_ERROR";